var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgVideoBackground = function SvgVideoBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.072c-4.319 0-7.833-3.516-7.833-7.834-.01-.125-.193-4.557 6.964-11.628l.689-.682.703.669c.74.703 7.222 7.004 7.311 11.622a7.57 7.57 0 01-2.196 5.486A7.944 7.944 0 0112 22.072zm-.159-17.336c-5.702 5.9-5.676 9.422-5.675 9.458.001 3.262 2.618 5.879 5.834 5.879a5.932 5.932 0 004.21-1.768 5.594 5.594 0 001.624-4.047c-.056-2.863-3.862-7.341-5.993-9.522z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.257 18.336l-.283-1.979c2.09-.299 2.385-2.914 2.396-3.025l1.99.193c-.14 1.483-1.18 4.395-4.103 4.811z"
  })));
};

export default SvgVideoBackground;